import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnswerModel } from 'src/app/models/answer.model';

@Component({
  selector: 'tx-document-data-dialog',
  templateUrl: './document-data-dialog.component.html',
  styleUrls: ['./document-data-dialog.component.scss']
})
export class DocumentDataDialogComponent implements OnInit {

	@Input() answers: Array<AnswerModel>;

	constructor(public activeModal: NgbActiveModal) {
    this.answers =[];
  }

  ngOnInit(): void {
  }

}
